import { put, takeLatest, call } from 'redux-saga/effects';
import {types as actionTypes} from '../ducks/coverages'
import {pageURL} from '../../utils/MicroServiceURL';
import {apiCall} from '../../utils/Api';
import {g_Failed} from '../../utils/Constants';

//GET EMP
function* getCoverages(action) {
    try{

        let response= yield call (apiCall, "get", pageURL.COVERAGES_URL);

        if(response.data.success===1){
         yield put({ type: actionTypes.GET_COVERAGES_SUCCESS, data:response.data});
        }
        else{
            yield put({ type: actionTypes.GET_COVERAGES_FAIL, data:response.data});
        }

    }catch(e){
        if(!!e.response && !!e.response.data)
        {
          yield put({ type: actionTypes.GET_COVERAGES_FAIL, data:e.response.data});
        }
        else {
          yield put({ type: actionTypes.GET_COVERAGES_FAIL, data:g_Failed});
        }
    }

}
export function* cavarageWatcher() {
     yield takeLatest(actionTypes.GET_COVERAGES, getCoverages)
}
